<div id="barrierefreiheitTastenbelegungContainer">
<div id="barrierefreiheitTastenbelegungTabelle">
  <div id="tabelleHeader">
    <strong>Befehl</strong>
    <strong>Windows</strong>
    <strong>MacOs</strong>
  </div>
  <div *ngFor="let shortcut of shortcuts" id="tabelleContent">
    <div class="tastenbelegungContent"><strong>{{shortcut.beschreibung}}</strong></div>
    <div class="tastenbelegungContent"><span class="tastenbelegungKachel">alt + {{shortcut.key}}</span></div>
    <div class="tastenbelegungContent"><span class="tastenbelegungKachel">control + {{shortcut.key}}</span></div>
  </div>
</div>
<!--  <div class="tastenbelegungContent"><strong>home</strong><span>==</span><div class="tastenbelegungKachel">alt + f</div></div>-->
<!--  <div class="tastenbelegungContent"><strong>speiseplan</strong><span>==</span><div class="tastenbelegungKachel">alt + s</div></div>-->
<!--  <div class="tastenbelegungContent"><strong>warenkorb</strong><span>==</span><div class="tastenbelegungKachel">alt + w</div></div>-->
<!--  <div class="tastenbelegungContent"><strong>bestellhistorie</strong><span>==</span><div class="tastenbelegungKachel">alt + b</div></div>-->
<!--  <div class="tastenbelegungContent"><strong>profil</strong><span>==</span><div class="tastenbelegungKachel">alt + p</div></div>-->
<!--  <div class="tastenbelegungContent"><strong>rechtstexte</strong><span>==</span><div class="tastenbelegungKachel">alt + r</div></div>-->
<!--  <div class="tastenbelegungContent"><strong>faq</strong><span>==</span><div class="tastenbelegungKachel">alt + q</div></div>-->
<!--  <div class="tastenbelegungContent"><strong>footer</strong><span>==</span><div class="tastenbelegungKachel">alt + f</div></div>-->
<!--  <div class="tastenbelegungContent"><strong>toolbar</strong><span>==</span><div class="tastenbelegungKachel">alt + t</div></div>-->
</div>
